module.exports = __webpack_public_path__ + "static/media/activity-improvement-desktop.0a26f315.svg";